// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_doc_common_doclist_app__2FAEQ"};